import { render } from "./AdminHead.vue?vue&type=template&id=9add130c"
import script from "./AdminHead.vue?vue&type=script&lang=js"
export * from "./AdminHead.vue?vue&type=script&lang=js"

import "./AdminHead.vue?vue&type=style&index=0&id=9add130c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__